<script>
	import { mapState, mapGetters } from "vuex";

	export default {
		props: {
			sectionId: {
				type: Number,
				required: true
			}
		},
		data() {
			return {
				totalExclTax: "0,00"
			};
		},
		computed: {
			...mapGetters(["totals", "currency", "mostUsedVatRate", "currencySpacing"]),
			...mapState({
				dynamicColspan: state => state.billing.dynamicColspan,
				headers: state => state.billing.headers,
				selectedVatValue: state => state.billing.selectedVatValue,
			}),
			unitSpacing() {
				return {
					"padding-right": `${this.currencySpacing * 6}px`
				};
			}
		},
		watch: {
			totals: {
				handler() {
					this.totalExclTax = this.totals.sections[this.sectionId].exclTax || "0,00";
				},
				immediate: true
			}
		},
		methods: {
			append(component) {
				this.$emit("event-append", {
					component,
					sectionId: this.sectionId,
					data: {vatPercentage: (this.selectedVatValue?? this.mostUsedVatRate)}
				});
			}
		}
	};
</script>

<template>
	<Fragment>
		<b-td :colspan="headers.line_number.enabled ? '2' : '1'" class="bgc-grey" style="    border-bottom-left-radius: 6px;">
			<b-row class="sinao-footer-row">
				<b-button class="sinao-clickable" variant="transparent" @click="append('entry')">
					<b-icon icon="plus-square-fill" class="font-size-icon" aria-hidden="true" />
					<span>{{ $t("Ligne") }}</span>
				</b-button>

				<b-button class="sinao-clickable" variant="transparent" @click="append('section')">
					<b-icon icon="view-stacked" class="font-size-icon" aria-hidden="true" />
					<span>{{ $t("Titre") }}</span>
				</b-button>

				<b-button class="sinao-clickable" variant="transparent" @click="append('comment')">
					<b-icon icon="chat-left" class="font-size-icon" aria-hidden="true" />
					<span>{{ $t("Commentaire") }}</span>
				</b-button>
			</b-row>
		</b-td>
		<b-td 
			:colspan="headers.line_number.enabled ? (dynamicColspan - 2) : (dynamicColspan - 1)"
			class="bgc-grey py-2 text-right text-muted subtotal-ht"
		>
			<span :style="unitSpacing"> {{ $t("Sous-total HT :") }} {{ totalExclTax | convertNumberToString(2) }}</span>
			<span style="font-weight: 700;">{{ currency }}</span>
		</b-td>
	</Fragment>
</template>

<style scoped lang="scss">
	@import "../../scss/variables.scss";

	.sinao-footer-row {
		width: 100%;
		opacity: 0.7;
		margin: 0;
		text-align: center;
		display: flex;
		justify-content: space-around;
	}

	.sinao-clickable {
		font-size: $font-size-normal;
		padding: 2px;
	}
	@media screen and (max-width: 180mm) {
		.sinao-clickable {
			.b-icon {
				font-size: $font-size-normal;
				padding: 0;
			}
			span {
				display: none;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.subtotal-ht {
			display: none;
		}
	}
</style>
